import { useMemo } from "react";
import {
  type Control,
  Controller,
  type FieldValues,
  type Path,
} from "react-hook-form";

import { MultiSelect2 } from "@/components/multi-select-2/MultiSelect2";
import { useResolveProjects } from "@/features/users/hooks/useResolveProjects";

type SelectAccountProps<T extends FieldValues> = {
  accountIdsField: Path<T>;
  control: Control<T>;
};

export function SelectAccounts<T extends FieldValues>({
  accountIdsField,
  control,
}: SelectAccountProps<T>) {
  const { data } = useResolveProjects();

  const accounts = useMemo(
    () =>
      (data || []).map((d) => ({
        avatar: undefined,
        description: "",
        href: `/projects/${d.id}`,
        id: d.id,
        textValue: d.name,
      })),
    [data],
  );

  return (
    <div className="space-y-2 mt-4">
      <Controller
        control={control}
        name={accountIdsField}
        render={({ field }) => (
          <MultiSelect2
            // errorMessage={errors.accounts?.message}
            label="Accounts"
            onRemove={(key) => {
              field.onChange(
                field.value.filter((id: number) => id !== Number(key)),
              );
            }}
            onSelect={(key) => {
              const numKey = Number(key);

              if (!field.value.includes(numKey)) {
                field.onChange([...field.value, numKey]);
              }
            }}
            options={accounts}
            placeholder="Search to add accounts..."
            requiredHint
            selectedIds={field.value}
          />
        )}
      />
    </div>
  );
}
